var _style, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 348 157",
    style: {
      enableBackground: "new 0 0 348 157"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F1F1F1;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "st0",
    d: "M4,22h98c2.2,0,4,1.8,4,4v63c0,2.2-1.8,4-4,4H4c-2.2,0-4-1.8-4-4V26C0,23.8,1.8,22,4,22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-4",
    className: "st0",
    d: "M125,0h98c2.2,0,4,1.8,4,4v63c0,2.2-1.8,4-4,4h-98c-2.2,0-4-1.8-4-4V4 C121,1.8,122.8,0,125,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-7",
    className: "st0",
    d: "M125,86h98c2.2,0,4,1.8,4,4v63c0,2.2-1.8,4-4,4h-98c-2.2,0-4-1.8-4-4V90 C121,87.8,122.8,86,125,86z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-8",
    className: "st0",
    d: "M246,64h98c2.2,0,4,1.8,4,4v63c0,2.2-1.8,4-4,4h-98c-2.2,0-4-1.8-4-4V68 C242,65.8,243.8,64,246,64z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty_state.36a862efe3b37c896de1324a04f152a7.svg";
export { ForwardRef as ReactComponent };